export default __webpack_public_path__ + "static/media/icons8-secured-letter.4cff6bd0.gif";